import { DEFAULT_GLTF_MEMORY_BUDGET } from '@/plugins/mesh/loaders/gltfLowMemory/lowMemoryOptions'
import type { MeshOptimizationOptions, MeshOptimizationOptionsInput } from '@/plugins/mesh/types'

/** 默认关闭的安全运行时优化配置。 */
export const DEFAULT_MESH_OPTIMIZATION_OPTIONS: Readonly<MeshOptimizationOptions> = {
  enabled: false,
  failureMode: 'fallback',
  instance: true,
  merge: true,
  minBatchSize: 2,
  partition: {
    enabled: true,
    minPrimitives: 16,
    maxDepth: 6,
    maxPrimitives: 32,
    maxVertices: 250_000,
    maxBatchCapacity: 64,
  },
  budget: DEFAULT_GLTF_MEMORY_BUDGET,
}

/** 合并默认、插件级和请求级优化配置。 */
export function resolveMeshOptimizationOptions(
  pluginOptions?: MeshOptimizationOptionsInput,
  requestOptions?: MeshOptimizationOptionsInput
): MeshOptimizationOptions {
  return {
    ...DEFAULT_MESH_OPTIMIZATION_OPTIONS,
    ...pluginOptions,
    ...requestOptions,
    partition: {
      ...DEFAULT_MESH_OPTIMIZATION_OPTIONS.partition,
      ...pluginOptions?.partition,
      ...requestOptions?.partition,
    },
    budget: {
      ...DEFAULT_MESH_OPTIMIZATION_OPTIONS.budget,
      ...pluginOptions?.budget,
      ...requestOptions?.budget,
    },
  }
}
